import { HOUR, MINUTES } from "../../../constants/common";
import LabeledDatePicker from "./LabeledDatePicker";
import LabeledFormikSelect from "./LabeledFormikSelect";

const DateTimePickerBlockFormik = ({
    label = "Survey Date",
    dateName = "date",
    hourName = "hour",
    minuteName = "minutes",
    maxDate,
    minDate = new Date(),
}) => {
    return (
        <div className=" flex w-full  justify-start items-start  gap-1 lg:gap-2  ">
            <LabeledDatePicker
                name={dateName}
                label={label}
                minDate={minDate}
                maxDate={maxDate}
            />
            <div className="w-1/4 lg:w-[47%]">
                <LabeledFormikSelect
                    name={hourName}
                    label="Hour"
                    required
                    options={HOUR}
                />
            </div>
            <div className="w-1/4 lg:w-[47%]">
                <LabeledFormikSelect
                    name={minuteName}
                    label="Min"
                    required
                    options={MINUTES}
                />
            </div>
        </div>
    );
};

export default DateTimePickerBlockFormik;
